import Constants from 'Constants';
import { getVersion } from 'utils';

function VersionMonitor() {
  return (
    <div className="min-w-100px absolute bottom-8 right-8 z-50 flex flex-col items-center rounded-lg bg-neutral-grey-2 px-4 py-2">
      <p className="w-fit text-sm text-neutral-grey-4">{getVersion()}</p>
      <p className="text-sm text-neutral-grey-4">{Constants.GIT_INFO}</p>
    </div>
  );
}

export default VersionMonitor;
